import { render, staticRenderFns } from "./ResearchBoxPlot.vue?vue&type=template&id=5247e479"
import script from "./ResearchBoxPlot.vue?vue&type=script&lang=js"
export * from "./ResearchBoxPlot.vue?vue&type=script&lang=js"
import style0 from "./ResearchBoxPlot.vue?vue&type=style&index=0&id=5247e479&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5247e479')) {
      api.createRecord('5247e479', component.options)
    } else {
      api.reload('5247e479', component.options)
    }
    module.hot.accept("./ResearchBoxPlot.vue?vue&type=template&id=5247e479", function () {
      api.rerender('5247e479', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchBoxPlot.vue"
export default component.exports